import React, { useState, useRef } from "react";
import SearchVehicleInspection from "../components/SearchVehicleInspection";
import { getNBAbyLicenseAndState } from "../services/nbaService";
import useShowMessages from "../hooks/useShowMessages";
import Loading from "../components/Loading";
import NextBestAction from "./NextBestAction";
import useLoading from "../hooks/useLoading";
import useStore from "../hooks/useStore";
import useLicensePlates from "../hooks/useLicensePlates";

const ServiceHistory = (props) => {
  const [licenseFound, setLicenseFound] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const { showMessage } = useShowMessages();
  const [showHistory, setShowHistory] = useState(false);
  const [vehicleNBA, setVehicleNBA] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState()
  const { setIsLoading } = useLoading()
  const [showList, setShowList] = useState(false)
  const [searchedValue, setSearchedValue] = useState([])
  const [comesFromNBA, setComesFromNBA] = useState(false)
  const [criteriaSelected, setcriteriaSelected] = useState(-1);
  const { storeId } = useStore();  
  const { licensePlatesToExclude } = useLicensePlates()
  
  const changeLicenseFound = (vehicleDataList) => {
    setVehicles(vehicleDataList);
    setLicenseFound(true);
  };

  const returnToResult = () => {
    setShowHistory(false);
    setVehicleNBA(null);
    setSelectedVehicle(null)
    setShowList(true)
    setComesFromNBA(true)
  };

  const returnToSearch = () => {
    setShowHistory(false);
    setVehicleNBA(null);
    setSelectedVehicle(null)
    setLicenseFound(false);
    setShowList(false)
    setComesFromNBA(false)
  };

  const showSnackBarMessage = (message, severity) => {
    showMessage(message, severity);
  };

  const verifyLicensePlateAndState = (licensePlate, state) => {
    return licensePlatesToExclude.find(obj => obj.license_plate === licensePlate && obj.state === state);
  }

  const toNextBestAction = async (selectedVehicleData) => {
    try {
      if (criteriaSelected !== 4 && !selectedVehicleData.state || !selectedVehicleData.licensePlate) {
        showSnackBarMessage(
          "This record has missing information and cannot be selected",
          "error"
        );
        return;
      }

      const licensePlateExcluded = verifyLicensePlateAndState(selectedVehicleData.licensePlate, selectedVehicleData.state)

      if(licensePlateExcluded) {
        showSnackBarMessage(
          "Service History currently unavailable for this license plate",
          "error"
        );
        return;
      }

      if (criteriaSelected === 4 && !selectedVehicleData.workOrderId) {
        showSnackBarMessage(
          "This record has missing information and cannot be selected",
          "error"
        )
        return;
      }
      setIsLoading(true);

      if(!licensePlateExcluded){ 
        const data = await getNBAbyLicenseAndState(selectedVehicleData.licensePlate, selectedVehicleData.state, storeId)
        if (!data) {
          showSnackBarMessage(
            "No data available",
            "error");
          setIsLoading(false);
          return;
        }
        else if (data.isInvalid) {
          showSnackBarMessage(
            data.description,
            "error");
          setIsLoading(false);
          return;
        }

        setIsLoading(false);
        setVehicleNBA({...data[0], id: selectedVehicleData.id});
        setSelectedVehicle(selectedVehicleData)
        setShowHistory(true);
      }
    } catch (error) {
      setIsLoading(false);
      showSnackBarMessage(
        "An error ocurred, please try again later",
        "error"
      );
    }
  };

  return (
    <>
      {showHistory ?
        <NextBestAction
          vehicleNBA={vehicleNBA}
          selectedVehicle={selectedVehicle}
          returnToSearch={returnToSearch}
          returnToResult={returnToResult}
        />
        :
        <SearchVehicleInspection
          onChangeLicenseFound={changeLicenseFound}
          onShowMessage={showSnackBarMessage}
          onLoading={setIsLoading}
          vehicleData={vehicles}
          nextBestAction={toNextBestAction}
          setShowList={setShowList}
          showList={showList}
          searchedValue={searchedValue}
          setSearchedValue={setSearchedValue}
          comesFromNBA={comesFromNBA}
          criteriaSelected={criteriaSelected}
          setcriteriaSelected={setcriteriaSelected}
        />
      }
      <Loading />
    </>
  );
};

export default ServiceHistory;
